export const aboutData = {
    title: "Who I am",
    description1: "My name's Mahammad Kasim. I'm a Full Stack  Developer, Graphic Designer, and Digital Marketing Specialist based in Sharjah, UAE.",
    description2: "I am a highly skilled and talented professional with a passion for technology and design. My diverse skill set in full-stack development, programming, graphic design, and digital marketing allows me to deliver creative and innovative solutions that meet my clients' needs.",    
    image: 1
}